import React from "react";
import {
  Card as MUICard,
  CardContent,
  Typography,
  IconButton,
  Grid,
  Box,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import "../assets/css/Card.css";

const Card = ({ sx, title, value, icon, info, image, color }) => {
  let iconColor = "";
  if (color === "1") iconColor = "#00BB9F";
  else if (color === "2") iconColor = "#6CD8BF";
  else if (color === "3") iconColor = "#B0EE93";
  else iconColor = color;

  return (
    <MUICard
      // className="metric-card"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        p: 1,
        borderRadius: 3,
        boxShadow: "none",
        ...sx,
      }}
    >
      <CardContent sx={{ flexGrow: 2 }}>
        <Grid
          container
          direction="column"
          justifyContent="center"
          // alignItems="center"
          spacing={1}
        >
          <Grid item>
            <Typography
              variant="h5"
              className="value"
              sx={{ my: 1, fontSize: { xs: "1.4rem", md: "1.6rem" } }}
            >
              {value}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              variant="subtitle1"
              className="title"
              sx={{ fontSize: { xs: "0.9rem", md: "1rem" } }}
            >
              {title}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>

      {(icon || info || image) && (
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          sx={{
            flexGrow: 1,
            ...(icon ? { mr: 2 } : {}), // Add margin if icon is present
          }}
          // mt="auto"
        >
          {icon && (
            <IconButton
              sx={{
                backgroundColor: iconColor,
                color: "white",
                "&:hover": { backgroundColor: iconColor },
                // ml: 1,
              }}
            >
              {React.cloneElement(icon, { sx: { fontSize: 24 } })}
            </IconButton>
          )}
          {info && (
            <IconButton sx={{ ml: 1 }}>
              <InfoIcon />
            </IconButton>
          )}
          {image && (
            <IconButton
              sx={{
                width: 42,
                height: 42,
                backgroundColor: iconColor,
                "&:hover": { backgroundColor: iconColor },
              }}
            >
              <img
                src={image}
                alt="Card Image"
                style={{ width: "24px", height: "24px" }}
              />
            </IconButton>
          )}
        </Box>
      )}
    </MUICard>
  );
};

export default Card;
